"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasCompletedAccountSetup = void 0;
const hasCompletedAccountSetup = (user) => Boolean(user?.username) || Boolean(user?.avererAccountId);
exports.hasCompletedAccountSetup = hasCompletedAccountSetup;
//# sourceMappingURL=accountSetup.js.map